import React, { Component } from "react";

import "./portal.css";
import eventBus from "../EventBus";

class Portal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isClicked: false,
    };
    this.handleHashChange = this.handleHashChange.bind(this);
    this.insertToken = this.insertToken.bind(this); // <== BIND THIS TOO
  }

  insertToken() {
    const authButton = Array.from(document.querySelectorAll("h5")).find(
      (h5) => h5.textContent.trim() === "Authentication"
    )?.parentElement?.parentElement?.parentElement?.parentElement;
    if (!authButton) {
      return;
    }
    authButton.click();
    const authSection = document.querySelector("form.rjsf");

    if (!authSection) {
      return;
    }
    authSection.classList.add("hideWindow");
    authButton.style.display = "block";
    const inputElem = document.querySelector('input[label="AccessToken"]');

    if (!inputElem) {
      return;
    }

    const inputEvent = new Event("input", { bubbles: true });
    const accessTokenValue = inputElem.value;

    const accessToken = this.props?.appContext?.state?.accessToken?.accessToken;
    if (accessToken) {
      inputElem.value = accessToken;
      inputElem._valueTracker.setValue(accessTokenValue);
      inputElem.dispatchEvent(inputEvent);
      inputElem.focus();
      authButton.click();
    } else {
      inputElem.dispatchEvent(inputEvent);
      inputElem.focus();
      authButton.click();
    }
    /*   setTimeout(() => {
      const authButton = Array.from(document.querySelectorAll("h5")).find(
        (h5) => h5.textContent.trim() === "Authentication"
      )?.parentElement?.parentElement?.parentElement?.parentElement;
      if (!authButton) {
        return;
      }
      authButton.click();
      const authSection = document.querySelector("form.rjsf");

      if (!authSection) {
        return;
      }
      authSection.classList.add("hideWindow");
      authButton.style.display = "block";
      const inputElem = document.querySelector('input[label="AccessToken"]');

      if (!inputElem) {
        return;
      }

      const inputEvent = new Event("input", { bubbles: true });
      const accessTokenValue = inputElem.value;

      const accessToken =
        this.props?.appContext?.state?.accessToken?.accessToken;
      if (localStorageService.getAccessToken() !== null) {
        console.log({
          localStorageService: localStorageService.getAccessToken(),
          accessToken,
        });
        inputElem.value = accessToken;
        inputElem._valueTracker.setValue(accessTokenValue);
        inputElem.dispatchEvent(inputEvent);
        inputElem.focus();
        authButton.click();
      } else {
        inputElem.dispatchEvent(inputEvent);
        inputElem.focus();
        authButton.click();
      }
    }, 1000); */
  }
  handleHashChange() {
    this.insertToken();
  }
  componentDidMount() {
    // Delay to allow portal DOM to update
    setTimeout(() => {
      this.insertToken();
    }, 500);
    eventBus.on("ButtonClicked", (data) => {
      this.setState({ isClicked: data.message });
    });

    window.addEventListener("hashchange", this.handleHashChange);
  }

  componentWillUnmount() {
    eventBus.remove("ButtonClicked");
    window.removeEventListener("hashchange", this.handleHashChange);
  }

  componentDidUpdate() {
    const accessToken = this.props?.appContext?.state?.accessToken?.accessToken;
    if (accessToken) {
      this.insertToken();
    }
  }

  render() {
    return (
      <>
        <div id="apimatic-widget" className="h-screen"></div>
      </>
    );
  }
}
export default Portal;
